<template>
<div>
    <sidebar-item :link="{ name: 'CLIENTES', icon: 'fas fa-user-friends text-info' }">
        <sidebar-item v-if="permissoes.clientesRead" :link="{ name: 'CLIENTES', path: '/clientes', icon: 'fas fa-user' }"></sidebar-item>
    </sidebar-item>
</div>
</template>

<script>
export default {
    name: 'SidebarCliente',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
}
</script>
